export var parseSearch = function (str) {
    if (str === void 0) { str = ''; }
    var result = {};
    if (!str) {
        return result;
    }
    var strArr = (/^[?#]/.test(str) ? str.slice(1) : str).split('&');
    return strArr.reduce(function (res, valueSting) {
        var _a = valueSting.split('='), key = _a[0], value = _a[1];
        if (key && value) {
            res[decodeURIComponent(key)] = decodeURIComponent(value);
        }
        return res;
    }, result);
};
//# sourceMappingURL=query-string.js.map